import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter';
export class GltfExporter {
    constructor() {
        this.exporter = new GLTFExporter();
    }
    export(scene) {
        return new Promise((resolve, reject) => {
            this.exporter.parse(scene, (gltf) => {
                resolve(gltf);
            }, reject, { forceIndices: true, binary: true });
        });
    }
}
//# sourceMappingURL=GltfExporter.js.map